import React from 'react'

const BottomText = () => {
  return (
    <div>
        <h2 style={{
            padding: "5em"
        }}
        >Wear something that makes a difference.</h2>
    </div>
  )
}

export default BottomText